import { Navigate } from "react-router-dom";


const ProtectedRoute = ({ children, isAuthenticated, completeProfile, showReferalPage }) => {

    if (!isAuthenticated) {
        return <Navigate to="../login" replace />;
    }
    else if(showReferalPage)
    	return <Navigate to="../referal" replace />;
    else if (!completeProfile) {
        return <Navigate to="../edit_profile" replace />;
    }

    return children;
}

export default ProtectedRoute;
